import { css } from 'react-emotion';
import { fontFamily, animationTransition } from '../../variables';
import { ColorTypes } from '@joykit/variables/colors';
const chroma = require('chroma-js');

export namespace styles {
  export const button = (
    backgroundColor: string,
    color: ColorTypes,
    tall: boolean = false,
    wide: boolean = false,
    transparent: boolean = false,
    rounded: boolean = false
  ) => {
    const fontColor = !transparent ? (color === 'gray' ? '#232323' : '#fff') : backgroundColor;
    return css({
      fontFamily,
      width: wide ? '100%' : undefined,
      minWidth: wide ? undefined : 128,
      padding: '0 25px',
      height: !tall ? '40px' : '48px',
      borderRadius: rounded ? 40 : '5px',
      border: 'none',
      backgroundColor: !transparent ? backgroundColor : `rgba(255, 255, 255, 0)`,
      color: fontColor,
      fontSize: '1.5rem',
      fontWeight: 600,
      fontStyle: 'normal',
      fontStretch: 'normal',
      letterSpacing: '.3px',
      textAlign: 'center',
      textDecoration: 'none',
      cursor: 'pointer',
      lineHeight: '40px',
      display: 'inline-block',
      outline: 'none',
      transition: animationTransition('background-color'),
      ':hover': {
        backgroundColor: !transparent
          ? chroma(backgroundColor)
              .darken(0.4)
              .css()
          : undefined
      },
      ':disabled': {
        opacity: 0.2,
        cursor: 'not-allowed'
      }
    });
  };
}
